/** PostHog / product flag key — must match dashboard */
export const AUTO_LESSON_ANALYSIS_FEATURE_FLAG = 'auto_lesson_analysis';

/**
 * Minutes of lesson credit one lesson consumes. Credits are stored in minutes
 * (1 credit === 1 minute), so a lesson costs 60 credits.
 */
export const LESSON_MINUTES = 60;

/**
 * Minutes of lesson credit deducted for each lesson that gets analysed by
 * Tutopiya AI. Must match the backend constant — checkout prices the add-on
 * from it and the backend deducts it after each lesson is analysed.
 */
export const AUTO_ANALYSIS_MINUTES_PER_LESSON = 15;

/**
 * Which of the three auto analysis switches the student saw or used. Sent with
 * every auto analysis event so the course-page control and the two checkout
 * controls can be compared separately.
 */
export type TAutoAnalysisSurface =
  | 'course_page'
  | 'checkout_one_time'
  | 'checkout_monthly';
